import { mallH5WxConfig } from '@/api/mall'

const CODE_KEY = 'mall_wx_code'

/**
 * 获取微信网页授权 code，必要时跳转微信授权页。
 * 授权后微信会带 code 回跳到当前页，本函数从 url 中读取并缓存。
 * 返回 code（已授权）或 null（未授权，且已触发跳转）。
 */
export async function ensureWxCode() {
  // 优先从 url 读取
  const url = new URL(window.location.href)
  let code = url.searchParams.get('code')
  if (code) {
    sessionStorage.setItem(CODE_KEY, code)
    // 清理 url 上的 code/state，避免分享时携带
    url.searchParams.delete('code')
    url.searchParams.delete('state')
    window.history.replaceState({}, document.title, url.toString())
    return code
  }
  // 其次从缓存读取
  code = sessionStorage.getItem(CODE_KEY)
  if (code) return code

  // 无 code，跳转微信授权
  try {
    const res = await mallH5WxConfig()
    const appid = res.data && res.data.appid
    if (!appid || appid.indexOf('xxxx') >= 0) {
      // 未配置真实 appid，本地开发直接返回占位
      return 'DEV_PLACEHOLDER_CODE'
    }
    const redirectUri = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search + window.location.hash)
    const scope = 'snsapi_base' // 静默授权，仅拿 openid
    const state = 'mall'
    const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
    // eslint-disable-next-line require-atomic-updates
    window.location.href = authUrl
    return null
  } catch (e) {
    console.error('获取微信配置失败', e)
    return null
  }
}

export function getWxCode() {
  return sessionStorage.getItem(CODE_KEY)
}

export function clearWxCode() {
  sessionStorage.removeItem(CODE_KEY)
}
